export const typeOfAlertDeleteConfirmationDialog = 'typeOfAlertDeleteConfirmationDialog';
